import axios from "axios";

// Base API : REACT_APP_API_URL (ex: https://flowdevis-backend.../)
// On supprime les / à la fin pour éviter les doublons
const API_BASE = (process.env.REACT_APP_API_URL || "http://localhost:5000").replace(
  /\/+$/,
  ""
);
export const API_URL = `${API_BASE}/api`;

const api = axios.create({
  baseURL: API_URL,
  timeout: 15000,
  withCredentials: true,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

// JWT basique (évite d'envoyer 'undefined'/'null')
const JWT_RE = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+$/;

// Évite multiples redirections simultanées (login / abonnement)
let redirecting = false;

/* ---------- Request interceptor ---------- */
api.interceptors.request.use(
  (config) => {
    config.headers = config.headers || {};

    // Auth
    const raw = localStorage.getItem("token");
    if (raw && JWT_RE.test(raw)) {
      config.headers.Authorization = `Bearer ${raw}`;
    }

    // Contexte non sensible
    config.headers["X-Client"] = "flowdevis-web";
    try {
      config.headers["X-TZ"] =
        Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
    } catch {
      config.headers["X-TZ"] = "UTC";
    }

    return config;
  },
  (error) => Promise.reject(error)
);

/* ---------- Response interceptor (401 + 402 abonnement + logs) ---------- */
api.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err?.response?.status;
    const url = err?.config?.url || "";
    const data = err?.response?.data;

    // Logs détaillés pour debug
    try {
      const text = err?.request?.responseText;
      // eslint-disable-next-line no-console
      console.error("AXIOS ERROR ➜", url, "status:", status);
      try {
        // eslint-disable-next-line no-console
        console.error("response.data:", JSON.stringify(data, null, 2));
      } catch {
        // eslint-disable-next-line no-console
        console.error("response.data (raw):", data);
      }
      if (typeof text === "string") {
        // eslint-disable-next-line no-console
        console.error("responseText (raw):", text.slice(0, 2000));
      }
    } catch {
      /* no-op */
    }

    // 402 / abonnement requis
    if (
      status === 402 ||
      (status === 403 &&
        (data?.error === "subscription_required" ||
          data?.code === "subscription_required"))
    ) {
      try {
        const pathname = window.location.pathname || "/";
        const search = window.location.search || "";

        const alreadyOnBilling = pathname.startsWith("/parametres/abonnement");
        const isBillingApi = /\/billing(\/|$)/.test(url || "");

        if (!alreadyOnBilling && !isBillingApi && !redirecting) {
          redirecting = true;
          const next = encodeURIComponent(pathname + search);
          window.location.assign(
            `/parametres/abonnement?reason=subscription_required&next=${next}`
          );
          return;
        }
      } catch {
        // si window indisponible, on laisse passer
      }
    }

    // 401 / token expiré
    if (status === 401) {
      const isAuthCall = /\/auth\/(login|register|google|refresh|logout)/.test(
        url
      );
      if (!isAuthCall && !redirecting) {
        redirecting = true;
        localStorage.removeItem("token");
        const next = encodeURIComponent(
          window.location.pathname + window.location.search
        );
        window.location.assign(`/login?reason=expired&next=${next}`);
        return;
      }
    }

    return Promise.reject(err);
  }
);

export default api;
